import React, { useState, useEffect } from 'react';
import { Table, Pagination } from "react-bootstrap";
import { getOrderByUser } from "../../components/Service/Oder";

const Order = () => {
    const [order, setOrder] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 7;

    useEffect(() => {
        const fetchData = async () => {
            const data = await getOrderByUser();
            setOrder(data.order_details || []);
        };
        fetchData();
    }, []);

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = order.slice(indexOfFirstRow, indexOfLastRow);

    const totalPages = Math.ceil(order.length / rowsPerPage);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div className="px-4 py-4">
            <Table bordered hover>
                <thead>
                    <tr>
                        <th>STT</th>
                        <th>Gói Dịch Vụ</th>
                        <th>IP Host</th>
                        <th>Trạng Thái</th>
                        <th>Hành Động</th>
                    </tr>
                </thead>
                <tbody>
                    {currentRows.map((muc, index) => (
                        <tr key={index}>
                            <td>{indexOfFirstRow + index + 1}</td>
                            <td>{muc?.package[0]?.name}</td>
                            <td>{muc?.ip}</td>
                            <td>
                                <span
                                    className={`badge ${muc.status === 0 ? "badge-warning" : muc.status === 3 ? "badge-secondary" : "badge-danger"
                                        }`}
                                >
                                    {muc.status === 0 ? "Pending" : muc.status === 3 ? "active" : "Processing"}
                                </span>
                            </td>
                            <td>
                                <div className="dropdown">
                                    <button className="btn btn-warning dropdown-toggle" type="button" id="actionMenu" data-bs-toggle="dropdown" aria-expanded="false">
                                        Hành Động
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="actionMenu">
                                        {muc.invoice_status === 0 ? (
                                            <>
                                                <li><a className="dropdown-item" href={`/cssp/server/detail/${muc.id}`}>Xem chi tiết</a></li>
                                                <li>
                                                    <a className="dropdown-item" href={`/invoice-detail/${muc.invoice_id}`}>
                                                        Gia Hạn
                                                    </a>
                                                </li>
                                            </>
                                        ) : (
                                            <li><a className="dropdown-item" href={`/cssp/server/detail/${muc.id}`}>Xem chi tiết</a></li>
                                        )}
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <div className="d-flex justify-content-center mt-4">
                <Pagination>
                    <Pagination.Prev
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Trước
                    </Pagination.Prev>

                    {[...Array(totalPages)].map((_, i) => (
                        <Pagination.Item
                            key={i + 1}
                            active={i + 1 === currentPage}
                            onClick={() => handlePageChange(i + 1)}
                        >
                            {i + 1}
                        </Pagination.Item>
                    ))}

                    <Pagination.Next
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Sau
                    </Pagination.Next>
                </Pagination>
            </div>
        </div>
    );
};

export default Order;
